export default __webpack_public_path__ + "static/media/Alpha Skull Helm.e086430d.jpg";